/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} one
 * @param {function} two
 * @returns {function|null}
 */

function createChainedFunction<T extends Function, U extends Function>(
  one?: T,
  two?: U
): T | U | (() => void) | null {
  if (one != undefined && two != undefined) {
    return function chainedFunction(this: T) {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  } else if (one != undefined) {
    return one;
  } else if (two != undefined) {
    return two;
  } else {
    return null;
  }
}

export default createChainedFunction;
